import * as yup from "yup";
import React from "react";
import { useQuery } from "@tanstack/react-query";
import { http } from "../../services/HttpService";
import { QUERY_KEYS, HTTP_ENDPOINTS } from "../../consts/api";

const responceSchema = yup.object({
  bookingUrl: yup.string().required(),
  domainName: yup.string().required(),
  useCustomDomain: yup.boolean(),
});

const composeResponse = (res) => {
  const data = res?.data?.data;

  return {
    bookingUrl: data.clinics[0]?.clinic_url,
    domainName: data.domain_name,
    useCustomDomain: Boolean(data?.use_custom_pp_domain),
  };
};

function useGetBookingUrlsQuery({ onError } = {}) {
  return useQuery({
    queryKey: [QUERY_KEYS.bookingUrl],
    queryFn: async () => {
      const res = await http.get(HTTP_ENDPOINTS.getBookingUrls());

      return responceSchema.validateSync(composeResponse(res), {
        strict: true,
      });
    },
    onError: () => {
      onError?.();
    },
  });
}

export const withGetBookingUrlsQuery = (Component) => {
  return function Wrapper(props) {
    const currentBookingUrls = useGetBookingUrlsQuery();
    return (
      <Component {...props} currentBookingUrls={currentBookingUrls?.data} />
    );
  };
};
